export default "https://cdn-gra.amplement.io/statics/images/pattern-file-link@2x.png";